import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface ActiveTab {
  name: string;
  href: string;
  sectionId: number;
  subsectionId: number;
}

export interface DocumentationState {
  activeTab: ActiveTab | undefined;
}

const initialState: DocumentationState = {
  activeTab: {
    name: 'Getting Started',
    href: '/documentation/introduction/getting_started',
    sectionId: 5,
    subsectionId: 7,
  },
};

const documentationSlice = createSlice({
  name: 'documentation',
  initialState,
  reducers: {
    setActiveTab: (state: DocumentationState, action: PayloadAction<ActiveTab | undefined>) => {
      state.activeTab = action.payload;
    },
  },
});

export const documentationActions = documentationSlice.actions;
export default documentationSlice.reducer;
